// © Microsoft Corporation. All rights reserved.

// Windows supported markets
// Copied over from MarketSelector EdgeNext config: https://www.msncms.microsoft.com/amp/document/BBX9bfc?mode=json
export const windowsMarkets = [
    {
        id: "ar-ae",
        value: "ar-ae",
        displayString: "الإمارات العربية المتحدة (العربية)",
        direction: "rtl"
    },
    {
        id: "ar-eg",
        value: "ar-eg",
        displayString: "مصر (العربية)",
        direction: "rtl"
    },
    {
        id: "ar-sa",
        value: "ar-sa",
        displayString: "المملكة العربية السعودية (العربية)",
        direction: "rtl"
    },
    {
        id: "bn-in",
        value: "bn-in",
        displayString: "India (বাংলা)",
        direction: "ltr"
    },
    {
        id: "cs-cz",
        value: "cs-cz",
        displayString: "Česká republika (čeština)",
        direction: "ltr"
    },
    {
        id: "da-dk",
        value: "da-dk",
        displayString: "Danmark (Dansk)",
        direction: "ltr"
    },
    {
        id: "de-at",
        value: "de-at",
        displayString: "Österreich (Deutsch)",
        direction: "ltr"
    },
    {
        id: "de-ch",
        value: "de-ch",
        displayString: "Schweiz (Deutsch)",
        direction: "ltr"
    },
    {
        id: "de-de",
        value: "de-de",
        displayString: "Deutschland (Deutsch)",
        direction: "ltr"
    },
    {
        id: "el-gr",
        value: "el-gr",
        displayString: "Ελλάδα (ελληνικά)",
        direction: "ltr"
    },
    {
        id: "en-ae",
        value: "en-ae",
        displayString: "United Arab Emirates (English)",
        direction: "ltr"
    },
    {
        id: "en-au",
        value: "en-au",
        displayString: "Australia (English)",
        direction: "ltr"
    },
    {
        id: "en-ca",
        value: "en-ca",
        displayString: "Canada (English)",
        direction: "ltr"
    },
    {
        id: "en-gb",
        value: "en-gb",
        displayString: "United Kingdom (English)",
        direction: "ltr"
    },
    {
        id: "en-ie",
        value: "en-ie",
        displayString: "Ireland (English)",
        direction: "ltr"
    },
    {
        id: "en-in",
        value: "en-in",
        displayString: "India (English)",
        direction: "ltr"
    },
    {
        id: "en-my",
        value: "en-my",
        displayString: "Malaysia (English)",
        direction: "ltr"
    },
    {
        id: "en-nz",
        value: "en-nz",
        displayString: "New Zealand (English)",
        direction: "ltr"
    },
    {
        id: "en-ph",
        value: "en-ph",
        displayString: "Philippines (English)",
        direction: "ltr"
    },
    {
        id: "en-sg",
        value: "en-sg",
        displayString: "Singapore (English)",
        direction: "ltr"
    },
    {
        id: "en-us",
        value: "en-us",
        displayString: "United States (English)",
        direction: "ltr"
    },
    {
        id: "en-xl",
        value: "en-xl",
        displayString: "International Edition (English)",
        direction: "ltr"
    },
    {
        id: "en-za",
        value: "en-za",
        displayString: "South Africa (English)",
        direction: "ltr"
    },
    {
        id: "es-ar",
        value: "es-ar",
        displayString: "Argentina (español)",
        direction: "ltr"
    },
    {
        id: "es-cl",
        value: "es-cl",
        displayString: "Chile (español)",
        direction: "ltr"
    },
    {
        id: "es-co",
        value: "es-co",
        displayString: "Colombia (español)",
        direction: "ltr"
    },
    {
        id: "es-es",
        value: "es-es",
        displayString: "España (español)",
        direction: "ltr"
    },
    {
        id: "es-mx",
        value: "es-mx",
        displayString: "México (español)",
        direction: "ltr"
    },
    {
        id: "es-pe",
        value: "es-pe",
        displayString: "Perú (español)",
        direction: "ltr"
    },
    {
        id: "es-us",
        value: "es-us",
        displayString: "United States (español)",
        direction: "ltr"
    },
    {
        id: "es-ve",
        value: "es-ve",
        displayString: "Venezuela (español)",
        direction: "ltr"
    },
    {
        id: "es-xl",
        value: "es-xl",
        displayString: "América Latina (español)",
        direction: "ltr"
    },
    {
        id: "fi-fi",
        value: "fi-fi",
        displayString: "Suomi (suomi)",
        direction: "ltr"
    },
    {
        id: "fr-be",
        value: "fr-be",
        displayString: "Belgique (français)",
        direction: "ltr"
    },
    {
        id: "fr-ca",
        value: "fr-ca",
        displayString: "Canada (français)",
        direction: "ltr"
    },
    {
        id: "fr-ch",
        value: "fr-ch",
        displayString: "Suisse (français)",
        direction: "ltr"
    },
    {
        id: "fr-fr",
        value: "fr-fr",
        displayString: "France (français)",
        direction: "ltr"
    },
    {
        id: "fr-xl",
        value: "fr-xl",
        displayString: "Afrique francophone (français)",
        direction: "ltr"
    },
    {
        id: "he-il",
        value: "he-il",
        displayString: "ישראל (עברית)",
        direction: "rtl"
    },
    {
        id: "hi-in",
        value: "hi-in",
        displayString: "India (हिंदी)",
        direction: "ltr"
    },
    {
        id: "hu-hu",
        value: "hu-hu",
        displayString: "Magyarország (magyar)",
        direction: "ltr"
    },
    {
        id: "id-id",
        value: "id-id",
        displayString: "Indonesia (Bahasa Indonesia)",
        direction: "ltr"
    },
    {
        id: "it-it",
        value: "it-it",
        displayString: "Italia (italiano)",
        direction: "ltr"
    },
    {
        id: "ja-jp",
        value: "ja-jp",
        displayString: "日本 (日本語)",
        direction: "ltr"
    },
    {
        id: "ko-kr",
        value: "ko-kr",
        displayString: "한국 (한국어)",
        direction: "ltr"
    },
    {
        id: "mr-in",
        value: "mr-in",
        displayString: "India (मराठी)",
        direction: "ltr"
    },
    {
        id: "nb-no",
        value: "nb-no",
        displayString: "Norge (norsk, bokmål)",
        direction: "ltr"
    },
    {
        id: "nl-be",
        value: "nl-be",
        displayString: "België (Nederlands)",
        direction: "ltr"
    },
    {
        id: "nl-nl",
        value: "nl-nl",
        displayString: "Nederland (Nederlands)",
        direction: "ltr"
    },
    {
        id: "pl-pl",
        value: "pl-pl",
        displayString: "Polska (polski)",
        direction: "ltr"
    },
    {
        id: "pt-br",
        value: "pt-br",
        displayString: "Brasil (português)",
        direction: "ltr"
    },
    {
        id: "pt-pt",
        value: "pt-pt",
        displayString: "Portugal (Português)",
        direction: "ltr"
    },
    {
        id: "ru-ru",
        value: "ru-ru",
        displayString: "Россия (Pусский)",
        direction: "ltr"
    },
    {
        id: "sv-se",
        value: "sv-se",
        displayString: "Sverige (svenska)",
        direction: "ltr"
    },
    {
        id: "te-in",
        value: "te-in",
        displayString: "India (తెలుగు)",
        direction: "ltr"
    },
    {
        id: "th-th",
        value: "th-th",
        displayString: "ไทย (ไทย)",
        direction: "ltr"
    },
    {
        id: "tr-tr",
        value: "tr-tr",
        displayString: "Türkiye (Türkçe)",
        direction: "ltr"
    },
    {
        id: "vi-vn",
        value: "vi-vn",
        displayString: "Việt Nam (Tiếng Việt)",
        direction: "ltr"
    },
    {
        id: "zh-cn",
        value: "zh-cn",
        displayString: "中华人民共和国 (简体中文)",
        direction: "ltr"
    },
    {
        id: "zh-hk",
        value: "zh-hk",
        displayString: "香港特别行政區 (繁體中文)",
        direction: "ltr"
    },
    {
        id: "zh-tw",
        value: "zh-tw",
        displayString: "台灣 (繁體中文)",
        direction: "ltr"
    }
];

/**
 * Sort the market options list descending order based on market displayString
 */
export function compareDisplayNameDesc(a: any, b: any): number {
    if (a.displayString < b.displayString) {
        return -1;
    }
    if (a.displayString > b.displayString) {
        return 1;
    }
    return 0;
}

/**
 * Check if market is RTL or LTR
 * @param currentMarket - current market
 */
export function isRtlMarket(currentMarket: string): boolean {
    if (document.dir !== "") {
        return document.dir === "rtl";
    }

    const marketInfo = windowsMarkets.find(market => market.id === currentMarket);

    return marketInfo && marketInfo.direction === "rtl";
}
